import React, { useEffect, useState } from "react";

import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import { Modal } from "reactstrap";
import ModalTitle from "../../UpdateModels/ModalTitle";
import ModelCategory from "../../UpdateModels/ModelCategory";
import ModelSubCategory from "../../UpdateModels/ModelSubCategory";
import ModalDescription from "../../UpdateModels/ModalDescription";
import ModelDuretion from "../../UpdateModels/ModelDuretion";
import ModelBudget from "../../UpdateModels/ModelBudget";
import ModelLanguage from "../../UpdateModels/ModelLanguage";
import ModelDeliverables from "../../UpdateModels/ModelDeliverables";
import ModelFile from "../../UpdateModels/ModelFile";
import ModelSkills from "../../UpdateModels/ModelSkills";
import ModelMilestones from "../../UpdateModels/ModelMilestones";
import ModelType from "../../UpdateModels/ModelType";
import axiosInstance from "../../../../../redux/api";
import CloudStorage from "../../../../../CloudStorage/CloudStorage";
import { useNavigate } from "react-router-dom";
import ModelDate from "../../UpdateModels/ModalDate";
import GlobalLoader from "../../../../Common/Loader/GlobalLoader";
import { urtoast } from "../../../../Layouts/CustomPopup/eventEmitter";
import CustomLoader from "../../../../Common/Loader/CustomLoader";
import ButtonLoader from "../../../../Common/Loader/ButtonLoader";
import DisplayFileProper from "../../../../Common/FilesRelevent/DisplayFileProper";
import {
  formatNumberWithCommas,
  getDateFormate,
  getMemberSince,
} from "../../../../Common/AllDateTimeReleventFormate";
import CustomReactQuillDescription from "../../../../Common/CustomeLabel/ReactQuill/CustomReactQuillDescription";
import ModalIndustry from "../../UpdateModels/ModalIndustry";
import { descriptionvalidation, lastdatevalidation, titlevalidation } from "../../../../Common/commonvalidation";
import CompetencieswithioutComma from "../../../../Common/CompetencieswithioutComma";

export default function CReviewContest({ formData, setFormData, setX }) {
  const [loading, setLoading] = useState(false);
  const laung = localStorage.getItem("laung");
  const [lan, setlan] = useState(laung ?? "en");
  const [modaltitle, setModaltitle] = useState(false);
  const [title, setTitle] = useState(formData.title);
  const [lastdate, setlastdate] = useState(formData?.last_date);
  const [modalcategory, setModalCategory] = useState(false);
  const [industryEditModal, setIndustryEditModal] = useState(false);
  const [category, setCategory] = useState(formData.category_index);
  const [modalsubcategory, setModalSubCategory] = useState(false);
  const [modaldescription, setModalDescription] = useState(false);
  const [description, setDescription] = useState(formData.description);
  const [modalduretion, setModalduretion] = useState(false);
  const [duration, setProjectduration] = useState(formData.duration);
  const [modalBudget, setModalBudget] = useState(false);
  const [price, setProjectbudget] = useState(formData.price);
  const [modalLanguage, setModalLanguege] = useState(false);
  const [language_id, setLanguege] = useState(formData.language_id);
  const [modaldeliverables, setModaldeliverables] = useState(false);
  const [deliverables, setExpecteddeliverables] = useState(
    formData.deliverables
  );
  const [modalfile, setModalFile] = useState(false);
  const [modalSkills, setModalSkills] = useState(false);
  const [modalMils, setModalMils] = useState(false);
  const [modaltype, setModaltype] = useState(false);
  const [modallast_date, setModallast_date] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    setFormData(formData);
  }, [formData]);

  const hitApi = () => {
    const data = {
      ...formData,
      title: title,
      description: description,
      price: price,
      deliverables: deliverables,
      last_date: lastdate,
    };
    setFormData(data);
  };

  const handleInputTitle = (e) => {
    setTitle(e.target.value);
  };
  const handleDateInputTitle = (e) => {
    setlastdate(e.target.value);
  };
  const handleInputDescription = (e) => {
    setDescription(e.target.value);
  };
  const handleInputDuretion = (e) => {
    setProjectduration(e.target.value);
  };
  const handleInputBudget = (e) => {
    setProjectbudget(e.target.value);
  };
  const handleInputExpecteddeliverables = (e) => {
    setExpecteddeliverables(e.target.value);
  };

  const handleSubmit = async (values) => {
    setLoading(true);
    try {
      const response = await axiosInstance.post("post/create", formData);
      if (response.data.status) {
        const state = {
          id: response?.data?.response?.id,
          type: 2,
          type_of_post: "contest",
          post_id: response?.data?.response?.id,
          post_price: response?.data?.response?.price,
          nav: "postlivepage",
        };
        navigate(`/${lan}/account/paymentmethodpage`, {
          state: { orderdetails: state },
        });
      }

      await new Promise((resolve) => setTimeout(resolve, 2000));
    } catch (error) {
      urtoast(error.message, 2);
    } finally {
      setLoading(false);
    }
  };

  const validationSchema = Yup.object().shape({
    type: Yup.string().required("This is required"),
    title: titlevalidation,
    industry_id: Yup.string().required("This is required"),
    category_id: Yup.string().required("This is required"),
    // sub_category_id: Yup.string().required('This is required'),
    description: descriptionvalidation,
    skills: Yup.array().required("This is required"),
    price: Yup.string().required("This is required"),
    last_date: lastdatevalidation,
    // duration_type: Yup.string().required('Duration is required'),
    // milestones: Yup.array().min(1, 'At least one milestone is required').required('This is required'),
    // files: Yup.array().min(1, 'At least one file is required').required('This is required'),
    deliverables: Yup.string().required("This is required"),
    language_id: Yup.string().required("This is required"),
  });

  return (
    <div className="bg-project">
      <Formik
        initialValues={formData}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
        enableReinitialize
      >
        {(formik) => (
          <Form>
            { }

            <div>
              <div className="col-lg-10   mx-auto project-det">
                <div className="project-first">
                  <h4>
                    {formData?.type == 1
                      ? "Project"
                      : formData?.type == 2
                        ? "Win business Opportunities (WBO)"
                        : formData?.type == 3
                          ? "Job"
                          : ""}{" "}
                    Summary
                  </h4>


                </div>
                <div className="project-row">
                  <div className="project-section">
                    <div>
                      <p>Contest title</p>
                      <h4>{formData?.title}</h4>
                    </div>
                    <span
                      onClick={() => {
                        setModaltitle(true);
                      }}
                    >
                      <img
                        src={`${CloudStorage.cloudurl}/Assets/Images/expertregisteration/edit.svg`}
                        alt=""
                      />
                    </span>
                  </div>
                  <ErrorMessage
                    name="title"
                    component="div"
                    className="error"
                  />
                  <div className="project-section">
                    <div>
                      <p>Industry</p>
                      <h4>{formData?.industry_index?.label}</h4>
                    </div>
                    <span
                      className="btn"
                      onClick={() => {
                        setIndustryEditModal(true);
                      }}
                    >
                      <img
                        src={`${CloudStorage.cloudurl}/Assets/Images/expertregisteration/edit.svg`}
                        alt=""
                      />
                    </span>
                  </div>
                  <ErrorMessage
                    name="title"
                    component="div"
                    className="error"
                  />

                  <div className="project-section">
                    <div>
                      <p>Category</p>
                      <h4>{formData?.category_index?.label}</h4>
                    </div>
                    <span
                      onClick={() => {
                        setModalCategory(true);
                      }}
                    >
                      <img
                        src={`${CloudStorage.cloudurl}/Assets/Images/expertregisteration/edit.svg`}
                        alt=""
                      />
                    </span>
                  </div>
                  <ErrorMessage
                    name="category_id"
                    component="div"
                    className="error"
                  />

                  <div className="project-section">
                    <div>
                      <p>Sub-Category</p>
                      <h4>{formData?.subcategory_index?.label}</h4>
                    </div>
                    <span
                      onClick={() => {
                        setModalSubCategory(true);
                      }}
                    >
                      <img
                        src={`${CloudStorage.cloudurl}/Assets/Images/expertregisteration/edit.svg`}
                        alt=""
                      />
                    </span>
                  </div>
                  <ErrorMessage
                    name="sub_category_id"
                    component="div"
                    className="error"
                  />

                  <div className="project-section">
                    <div>
                      <p>Prize money</p>
                      <h4>
                        {formData?.price && "SAR "}
                        {formatNumberWithCommas(formData?.price)}
                      </h4>
                    </div>
                    <span
                      onClick={() => {
                        setModalBudget(true);
                      }}
                    >
                      <img
                        src={`${CloudStorage.cloudurl}/Assets/Images/expertregisteration/edit.svg`}
                        alt=""
                      />
                    </span>
                  </div>
                  <ErrorMessage
                    name="price"
                    component="div"
                    className="error"
                  />

                  <div className="project-section">
                    <div>
                      <p>Competition Lastdate</p>
                      <h4>
                        {(lastdate || formData?.last_date)
                          ? getMemberSince(lastdate || formData?.last_date)
                          : ""}{" "}
                      </h4>
                    </div>
                    <span
                      onClick={() => {
                        setModallast_date(true);
                      }}
                    >
                      <img
                        src={`${CloudStorage.cloudurl}/Assets/Images/expertregisteration/edit.svg`}
                        alt=""
                      />
                    </span>
                  </div>

                  <ErrorMessage
                    name="last_date"
                    component="div"
                    className="error"
                  />

                  <div className="project-section">
                    <div>
                      <p>Description</p>
                      <CustomReactQuillDescription
                        value={formData?.description}
                      />
                    </div>
                    <span
                      onClick={() => {
                        setModalDescription(true);
                      }}
                    >
                      <img
                        src={`${CloudStorage.cloudurl}/Assets/Images/expertregisteration/edit.svg`}
                        alt=""
                      />
                    </span>
                  </div>

                  <ErrorMessage
                    name="description"
                    component="div"
                    className="error"
                  />

                  <div className="project-section">
                    <div>
                      <p>Competencies</p>
                      <CompetencieswithioutComma formData={formData} />
                    </div>
                    <span
                      onClick={() => {
                        setModalSkills(true);
                      }}
                    >
                      <img
                        src={`${CloudStorage.cloudurl}/Assets/Images/expertregisteration/edit.svg`}
                        alt=""
                      />
                    </span>
                  </div>
                  <ErrorMessage
                    name="skills"
                    component="div"
                    className="error"
                  />

                  <div className="project-section">
                    <div className="w-100">
                      <p>Attachments</p>
                      <div className="images image-row1 row">
                        {Array.isArray(formData.files) &&
                          formData.files?.length > 0 ? (
                          <>
                            {formData.files.map((item, index) => (
                              <div className="col-md-4" key={index}>
                                <DisplayFileProper item={item} />
                              </div>
                            ))}
                          </>
                        ) : (
                          <p className="text-muted">
                            {/* <i className="fas fa-info-circle"></i> Please attach
                            the required files to proceed. */}
                          </p>
                        )}
                      </div>
                    </div>
                    <span
                      className="btn"
                      onClick={() => {
                        setModalFile(true);
                      }}
                    >
                      <img
                        src={`${CloudStorage.cloudurl}/Assets/Images/expertregisteration/edit.svg`}
                        alt=""
                      />
                    </span>
                  </div>
                  <ErrorMessage
                    name="files"
                    component="div"
                    className="error"
                  />

                  <div className="project-section">
                    <div>
                      <p>Expected deliverables</p>
                      <CustomReactQuillDescription
                        value={formData?.deliverables}
                      />
                    </div>
                    <span
                      onClick={() => {
                        setModaldeliverables(true);
                      }}
                    >
                      <img
                        src={`${CloudStorage.cloudurl}/Assets/Images/expertregisteration/edit.svg`}
                        alt=""
                      />
                    </span>
                  </div>
                  <ErrorMessage
                    name="deliverables"
                    component="div"
                    className="error"
                  />

                  <div className="project-section">
                    <div>
                      <p>Preferred Language of Work Submission</p>
                      <h4>{formData?.languageindex?.label}</h4>
                    </div>
                    <span
                      onClick={() => {
                        setModalLanguege(true);
                      }}
                    >
                      <img
                        src={`${CloudStorage.cloudurl}/Assets/Images/expertregisteration/edit.svg`}
                        alt=""
                      />
                    </span>
                  </div>
                  <ErrorMessage
                    name="language_id"
                    component="div"
                    className="error"
                  />
                </div>
                <div >
                  {loading ? (
                    <ButtonLoader />
                  ) : (
                    <button type="submit" className="summary-post-job" disabled={loading} onClick={formik.handleSubmit}>
                      Post{" "}
                      {formData?.type == 1
                        ? "Project"
                        : formData?.type == 2
                          ? "Contest"
                          : formData?.type == 3
                            ? "Job"
                            : ""}
                      <img
                        src={`${CloudStorage.cloudurl}/Assets/Images/common/right-arrow.svg`}
                        alt=""
                      />
                    </button>
                  )}
                </div>
              </div>
              <Modal
                className="popupmodal"
                isOpen={modaltitle}
                toggle={() => setModaltitle((state) => !state)}
              >
                <ModalTitle
                  title={title}
                  setModaltitle={setModaltitle}
                  handleInputTitle={handleInputTitle}
                  hitApi={hitApi}
                />
              </Modal>
              <Modal
                className="popupmodal"
                isOpen={modallast_date}
                toggle={() => setModallast_date((state) => !state)}
              >
                <ModelDate
                  lastdate={lastdate}
                  setModallast_date={setModallast_date}
                  handleDateInputTitle={handleDateInputTitle}
                  hitApi={hitApi}
                />
              </Modal>
              <Modal
                className="popupmodal"
                isOpen={industryEditModal}
                toggle={() => setIndustryEditModal((state) => !state)}
              >
                <ModalIndustry
                  formData={formData}
                  setFormData={setFormData}
                  setIndustryEditModal={setIndustryEditModal}
                />
              </Modal>
              <Modal
                className="popupmodal"
                isOpen={modalcategory}
                toggle={() => setModalCategory((state) => !state)}
              >
                <ModelCategory
                  formData={formData}
                  setFormData={setFormData}
                  category={category}
                  setModalCategory={setModalCategory}
                />
              </Modal>
              <Modal
                className="popupmodal"
                isOpen={modalsubcategory}
                toggle={() => setModalSubCategory((state) => !state)}
              >
                <ModelSubCategory
                  parentid={formData.category_id}
                  formData={formData}
                  setFormData={setFormData}
                  setModalSubCategory={setModalSubCategory}
                />
              </Modal>
              <Modal
                className="popupmodal"
                isOpen={modaldescription}
                toggle={() => setModalDescription((state) => !state)}
              >
                <ModalDescription
                  setFormData={setFormData}
                  description={description}
                  setModalDescription={setModalDescription}
                  handleInputDescription={handleInputDescription}
                  hitApi={hitApi}
                />
              </Modal>
              <Modal
                className="popupmodal"
                isOpen={modalduretion}
                toggle={() => setModalduretion((state) => !state)}
              >
                <ModelDuretion
                  formData={formData}
                  setFormData={setFormData}
                  duration={duration}
                  setModalduretion={setModalduretion}
                  handleInputDuretion={handleInputDuretion}
                  hitApi={hitApi}
                />
              </Modal>
              <Modal
                className="popupmodal"
                isOpen={modalBudget}
                toggle={() => setModalBudget((state) => !state)}
              >
                <ModelBudget
                  price={price}
                  setModalBudget={setModalBudget}
                  handleInputBudget={handleInputBudget}
                  hitApi={hitApi}
                />
              </Modal>
              <Modal
                className="popupmodal"
                isOpen={modalLanguage}
                toggle={() => setModalLanguege((state) => !state)}
              >
                <ModelLanguage
                  formData={formData}
                  setFormData={setFormData}
                  language_id={language_id}
                  setModalLanguege={setModalLanguege}
                />
              </Modal>
              <Modal
                className="popupmodal"
                isOpen={modaldeliverables}
                toggle={() => setModaldeliverables((state) => !state)}
              >
                <ModelDeliverables
                  setFormData={setFormData}
                  deliverables={deliverables}
                  setModaldeliverables={setModaldeliverables}
                  handleInputExpecteddeliverables={
                    handleInputExpecteddeliverables
                  }
                  hitApi={hitApi}
                />
              </Modal>
              <Modal
                className="popupmodal"
                isOpen={modalfile}
                toggle={() => setModalFile((state) => !state)}
              >
                <ModelFile
                  formData={formData}
                  setFormData={setFormData}
                  setModalFile={setModalFile}
                />
              </Modal>
              <Modal
                className="popupmodal"
                isOpen={modalSkills}
                toggle={() => setModalSkills((state) => !state)}
              >
                <ModelSkills
                  formData={formData}
                  setFormData={setFormData}
                  setModalSkills={setModalSkills}
                />
              </Modal>
              <Modal
                className="popupmodal"
                isOpen={modalMils}
                toggle={() => setModalMils((state) => !state)}
              >
                <ModelMilestones
                  formData={formData}
                  setFormData={setFormData}
                  setModalMils={setModalMils}
                />
              </Modal>
              <Modal
                className="popupmodal"
                isOpen={modaltype}
                toggle={() => setModaltype((state) => !state)}
              >
                <ModelType
                  formData={formData}
                  setFormData={setFormData}
                  setModaltype={setModaltype}
                />
              </Modal>
            </div>
          </Form>
        )}
      </Formik>
    </div>
  );
}
